<template>
    <BreadCrumb PageTitle="Liste des Magasin" />
    <ListeMagasin />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeMagasin from "../../components/Magasin/ListeMagasin.vue";
  
  export default defineComponent({
    name: "ListeMagasinPage",
    components: {
      BreadCrumb,
      ListeMagasin,
    },
  });
  </script>